export const commonTranslations = {
    en: {
        common: {
            languages: {
                english: 'English',
                arabic: 'Arabic'
            },
            actions: {
                save: 'Save',
                cancel: 'Cancel',
                edit: 'Edit',
                delete: 'Delete',
                add: 'Add',
                search: 'Search',
                filter: 'Filter',
                print: 'Print',
                close: 'Close',
                proceed: 'Proceed',
                confirm: 'Confirm',
                clear: 'Clear',
                remove: 'Remove',
                checkout: 'Checkout',
                back: 'Back',
                login: 'Login'
            },
            messages: {
                success: 'Operation successful',
                error: 'An error occurred',
                loading: 'Loading...',
                confirm: 'Are you sure?',
                required: 'This field is required',
                processing: 'Processing...',
                saving: 'Saving...',
                deleting: 'Deleting...',
                updating: 'Updating...',
                loggingIn: 'Logging in...',
                loginError: 'Failed to login. Please try again.',
                settingsSaved: 'Settings saved successfully'
            },
            auth: {
                welcome: 'Welcome back! Please login to continue.',
                email: 'Email',
                password: 'Password',
                loginButton: 'Login',
                appName: 'Restaurant POS',
                userNumber: 'User Number'
            },
            navigation: {
                dashboard: 'Dashboard',
                settings: 'Settings',
                logout: 'Logout'
            },
            status: {
                active: 'Active',
                inactive: 'Inactive',
                pending: 'Pending',
                completed: 'Completed',
                cancelled: 'Cancelled'
            },
            slug: 'URL Slug'
        }
    },
    ar: {
        common: {
            languages: {
                english: 'الإنجليزية',
                arabic: 'العربية'
            },
            actions: {
                save: 'حفظ',
                cancel: 'إلغاء',
                edit: 'تعديل',
                delete: 'حذف',
                add: 'إضافة',
                search: 'بحث',
                filter: 'تصفية',
                print: 'طباعة',
                close: 'إغلاق',
                proceed: 'متابعة',
                confirm: 'تأكيد',
                clear: 'مسح',
                remove: 'إزالة',
                checkout: 'إتمام الطلب',
                back: 'رجوع',
                login: 'تسجيل الدخول'
            },
            messages: {
                success: 'تمت العملية بنجاح',
                error: 'حدث خطأ',
                loading: 'جاري التحميل...',
                confirm: 'هل أنت متأكد؟',
                required: 'هذا الحقل مطلوب',
                processing: 'جاري المعالجة...',
                saving: 'جاري الحفظ...',
                deleting: 'جاري الحذف...',
                updating: 'جاري التحديث...',
                loggingIn: 'جاري تسجيل الدخول...',
                loginError: 'فشل تسجيل الدخول. الرجاء المحاولة مرة أخرى.',
                settingsSaved: 'تم حفظ الإعدادات بنجاح'
            },
            auth: {
                welcome: 'مرحباً بعودتك! الرجاء تسجيل الدخول للمتابعة.',
                email: 'البريد الإلكتروني',
                password: 'كلمة المرور',
                loginButton: 'تسجيل الدخول',
                appName: 'نظام المطعم',
                userNumber: 'رقم المستخدم'
            },
            navigation: {
                dashboard: 'لوحة التحكم',
                settings: 'الإعدادات',
                logout: 'تسجيل الخروج'
            },
            status: {
                active: 'نشط',
                inactive: 'غير نشط',
                pending: 'قيد الانتظار',
                completed: 'مكتمل',
                cancelled: 'ملغي'
            },
            slug: 'الرابط المختصر'
        }
    }
};
